import 'css-chunk:src/app/containers/Home/OrganizationsView/ClientGroup/ClientGroupsView.scss';export default {
  "ClientGroupsView": "_ClientGroupsView_hmmc2_1"
};